/**
 * Turn CMS / static paths into site-root URLs so they work from any locale prefix
 * (e.g. /en/property) and always hit nginx `location /images`, not /{lang}/images/...
 *
 * - `images/foo.png` → `/images/foo.png`
 * - `/images/foo.png` or `https://...` → unchanged
 */
export function publicAssetUrl(url) {
  if (url == null || url === '') return url;
  if (typeof url !== 'string') return url;
  const t = url.trim();
  if (!t) return url;
  if (/^(https?:|\/\/|data:|blob:)/i.test(t)) return t;
  if (t.startsWith('/')) return t;
  return `/${t.replace(/^\.+\//, '')}`;
}
